<template>
  <b-list-group v-if="!isLoading" v-show="show" class="card__online-meeting w-100">
    <b-list-group-item>
      <meeting-section
        v-model="show"
        :section="section"
        :number-of-online-meeting="learningUnit.number_of_online_meeting"
        only-show-next-meeting
      />
    </b-list-group-item>

    <b-list-group-item>
      <base-start-meeting-button class="my-2" :section="section" />
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import Meeting from '@/models/Meeting';
import MeetingSection from '@/views/Section/components/MeetingSection';
import BaseStartMeetingButton from '@/components/base-components/BaseStartMeetingButton';

export default {
  components: {
    MeetingSection,
    BaseStartMeetingButton
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    section: {
      type: Section,
      required: true
    }
  },

  data() {
    return {
      show: true,
      isLoading: true
    };
  },

  async mounted() {
    await this.fetchMeetings();
  },

  methods: {
    async fetchMeetings() {
      let promise;

      this.isLoading = true;
      try {
        promise = await Meeting.api().getMeetingBySection(this.section.id);
      } catch (error) {
        this.$toast.error('Cannot load meetings, please try again');
      }
      this.isLoading = false;

      return promise;
    }
  }
};
</script>
